/**
 * Custom error classes for specific HTTP status codes
 */

export class ErrorUnauthorized extends Error {
  statusCode = 401
  constructor(message = 'Unauthorized', public context?: unknown) {
    super(message)
    this.name = 'ErrorUnauthorized'
    Object.setPrototypeOf(this, ErrorUnauthorized.prototype)
  }
}

export class ErrorForbidden extends Error {
  statusCode = 403
  constructor(message = 'Forbidden', public context?: unknown) {
    super(message)
    this.name = 'ErrorForbidden'
    Object.setPrototypeOf(this, ErrorForbidden.prototype)
  }
}

export class ErrorNotFound extends Error {
  statusCode = 404
  constructor(message = 'Not Found', public context?: unknown) {
    super(message)
    this.name = 'ErrorNotFound'
    Object.setPrototypeOf(this, ErrorNotFound.prototype)
  }
}

